import * as React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AttioFieldSelect, AttioField } from "./AttioFieldSelect";
import { X, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface AttioDefaultFieldProps {
    attioField: string;
    value: string;
    onUpdate: (attioField: string, value: string) => void;
    onRemove: () => void;
    availableFields: AttioField[];
}

export function AttioDefaultField({
    attioField,
    value,
    onUpdate,
    onRemove,
    availableFields
}: AttioDefaultFieldProps) {
    const selectedField = availableFields.find(f => f.name === attioField);
    const isConfigured = Boolean(attioField && value);

    return (
        <div className={cn(
            "rounded-lg border p-3 transition-all",
            isConfigured
                ? "bg-muted/30 border-border"
                : "border-dashed"
        )}>
            <div className="flex items-center gap-3">
                <div className="flex-1 min-w-0">
                    <AttioFieldSelect
                        fields={availableFields}
                        value={attioField}
                        onSelect={(field) => onUpdate(field, value)}
                        placeholder="Select Attio attribute"
                        simpleDisplay
                    />
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
                <div className="flex-1 min-w-0">
                    <Input
                        value={value}
                        onChange={(e) => onUpdate(attioField, e.target.value)}
                        placeholder="Default value"
                        className="h-9"
                    />
                </div>
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={onRemove}
                    className="h-8 w-8 text-muted-foreground hover:text-destructive flex-shrink-0"
                >
                    <X className="h-4 w-4" />
                </Button>
            </div>
            {selectedField && (
                <p className="text-xs text-muted-foreground mt-2 ml-1">
                    <span className="capitalize">{selectedField.groupName}</span>
                    {selectedField.type && <span> • {selectedField.type}</span>}
                    {selectedField.description && <span> • {selectedField.description}</span>}
                </p>
            )}
        </div>
    );
}
